// Copyright (c) 2026 CTO's Club LLC. All rights reserved.

export const CloverWebhookPaymentOperation = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
} as const;

export type CloverWebhookPaymentOperation =
    (typeof CloverWebhookPaymentOperation)[keyof typeof CloverWebhookPaymentOperation];

export interface CloverWebhookVerificationRequest {
    readonly verificationCode: string;
}

export interface CloverWebhookPaymentUpdate {
    readonly objectId: string;
    readonly type: CloverWebhookPaymentOperation;
    readonly ts: number;
}

export interface CloverWebhookNotificationRequest {
    readonly appId: string;
    readonly merchants: Readonly<Record<string, readonly CloverWebhookPaymentUpdate[]>>;
}

export type CloverWebhookRequest =
    | CloverWebhookVerificationRequest
    | CloverWebhookNotificationRequest;

export interface CloverWebhookAuthenticationInput {
    readonly cloverAuth?: string;
}

export interface CloverWebhookProcessingResult {
    readonly attempted: number;
    readonly processed: number;
    readonly failed: number;
}
